import { render, staticRenderFns } from "./channel-janus.vue?vue&type=template&id=097b2fae&lang=pug&"
import script from "./channel-janus.vue?vue&type=script&lang=js&"
export * from "./channel-janus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports